import Vue from 'vue';
export const appEvent = new Vue();

export default {
  price(p, variant_id = '', value_id = '') {
    if (p && p.variants.length)
      return p.variants.reduce((prev, current) => {
        if (variant_id === current.id && value_id)
          return prev + current.values.find(val => val.id === value_id).price;
        return prev + current.value.price;
      }, p.price);
    return p.price || 0;
  },
  discountedPrice(p, variant_id = '', value_id = '') {
    return (
      this.price(p, variant_id, value_id) -
      (this.price(p, variant_id, value_id) * p.discount) / 100
    );
  },
  emit(event, data) {
    appEvent.$emit(event, data);
  },
};
